import '../style/Navbar.css';
import { useEffect, useState } from 'react';

function scrollToTarget(id) {
  if (typeof window === 'undefined' || !id) return false;
  const target = document.getElementById(id);
  if (!target) return false;

  const nav = document.querySelector('.Navbar');
  const navOffset = nav ? nav.offsetHeight + 8 : 90;
  const top = target.getBoundingClientRect().top + window.scrollY - navOffset;

  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  return true;
}

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const onResize = () => {
      if (window.innerWidth > 720) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleNavClick = (event, path, hash = '') => {
    if (typeof window === 'undefined') return;

    const onSamePath = window.location.pathname === path;
    const targetId = hash.replace('#', '');

    if (!onSamePath) {
      if (targetId) {
        event.preventDefault();
        window.location.assign(`${path}${hash}`);
      }
      return;
    }

    event.preventDefault();

    if (targetId) {
      const didScroll = scrollToTarget(targetId);
      if (didScroll) {
        window.history.replaceState(null, '', `${path}${hash}`);
      }
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.history.replaceState(null, '', path);
  };

  const onMenuLinkClick = (event, path, hash = '') => {
    handleNavClick(event, path, hash);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="Navbar" aria-label="Primary">
      <a
        className="Navbar-brand"
        href="/#home"
        aria-label="Go to home"
        onClick={(e) => onMenuLinkClick(e, '/', '#home')}
      >
        <img
          className="Navbar-logo"
          src={`${process.env.PUBLIC_URL}/image/abstanLogo.png`}
          alt="Abstan Logistics logo"
        />
        <span className="Navbar-name">Abstan Logistics</span>
      </a>

      <button
        type="button"
        className="Navbar-toggle"
        aria-label="Toggle navigation menu"
        aria-expanded={isMobileMenuOpen}
        onClick={() => setIsMobileMenuOpen((open) => !open)}
      >
        <span />
        <span />
        <span />
      </button>

      <ul className={isMobileMenuOpen ? 'Navbar-menu Navbar-menuOpen' : 'Navbar-menu'}>
        <li>
          <a href="/#home" onClick={(e) => onMenuLinkClick(e, '/', '#home')}>
            Home
          </a>
        </li>
        <li>
          <a
            href="/about#about-hero"
            onClick={(e) => onMenuLinkClick(e, '/about', '#about-hero')}
          >
            About Us
          </a>
        </li>
        <li>
          <a
            href="/#services"
            onClick={(e) => onMenuLinkClick(e, '/', '#services')}
          >
            Services
          </a>
        </li>
        <li>
          <a
            href="/contact#contact-hero"
            onClick={(e) => onMenuLinkClick(e, '/contact', '#contact-hero')}
          >
            Contact
          </a>
        </li>
        <li className="Navbar-quoteMobile">
          <a
            className="Navbar-linkQuote Navbar-linkQuoteButton"
            href="/quote"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Request a Qoute
          </a>
        </li>
      </ul>

      <a className="Navbar-quoteDesktop Navbar-linkQuote Navbar-linkQuoteButton" href="/quote">
        Request a Qoute
      </a>
    </nav>
  );
}

